import React, { useState } from "react";
import { priceTiers } from "../../data/megapack";
import { CTAButton } from "../CTAButton";
import { DiscountBadge } from "../DiscountBadge";
import { E } from "../Emoji";
export function PricingSection() {
  const [selected, setSelected] = useState<"standard" | "pro">("pro");
  const tiers = [priceTiers.standard, priceTiers.pro];
  const active = priceTiers[selected];
  return <section id="elegi" aria-labelledby="elegi-title" className="scroll-mt-4 bg-night" data-id="element-210" data-mp="24228xxe1kgpm">
      <div className="mx-auto max-w-2xl px-5 py-14" data-id="element-211" data-mp="1z2645vxisl90">
        <h2 id="elegi-title" className="text-center text-3xl font-black text-white" data-id="element-212" data-mp="1z1e8kl3xaniq">
          ELEGÍ TU <span className="text-bright" data-id="element-213" data-mp="1u3uupmb50crb">MEGAPACK</span>
        </h2>
        <div role="radiogroup" aria-label="Elegí tu versión" className="mt-7 space-y-3" data-id="element-214" data-mp="1p5b3b6dry8rk">
          {tiers.map(t => {
          const isOn = selected === t.id;
          return <button key={t.id} type="button" role="radio" aria-checked={isOn} onClick={() => setSelected(t.id)} className={`flex w-full items-center gap-3 rounded-2xl border-2 p-4 text-left transition-[border-color,background-color] duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-sky/40 ${isOn ? "border-bright bg-navy shadow-[0_0_24px_rgba(77,148,255,0.3)]" : "border-line/40 bg-abyss hover:border-line"}`} data-id="element-215" data-mp="3ji0ydrfvpo0j">
                <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${isOn ? "border-bright" : "border-mute"}`} aria-hidden="true" data-id="element-216" data-mp="xt5ngoajolj2">
                  {isOn && <span className="h-2.5 w-2.5 rounded-full bg-bright" data-id="element-217" data-mp="1bt7yprockgpc" />}
                </span>
                <div className="min-w-0 flex-1" data-id="element-218" data-mp="1gkg9os5bsa4m">
                  <p className="text-lg" data-id="element-219" data-mp="1gm9l0kqvviiy"><E data-id="element-220" data-mp="1qg6tnwmext8t">{t.emoji}</E></p>
                  <p className="font-black uppercase leading-tight text-white" data-id="element-221" data-mp="1qf417k9fziqs">
                    <E data-id="element-222" data-mp="1lgkal6jwlis3">{t.title}</E>
                  </p>
                  <p className="text-sm text-white/75" data-id="element-223" data-mp="1lezgfi1i41ur">{t.subtitle}</p>
                  <p className="mt-1 text-xs font-bold text-sky" data-id="element-224" data-mp="1he5xz46tvf99">{t.idealFor}</p>
                </div>
                <div className="shrink-0 text-right" data-id="element-225" data-mp="1cfvxqf68xogs">
                  {t.referencePrice && <p className="text-xs text-mute line-through" data-id="element-226" data-mp="17hks6gmzi04d">{t.referencePrice}</p>}
                  <p className="whitespace-nowrap text-xl font-black text-white md:text-2xl" data-id="element-227" data-mp="12q2mxgdxhddl">{t.price}</p>
                  <div className="mt-1" data-id="element-228" data-mp="xqq374icsmf8">
                    <DiscountBadge tier={t} data-id="element-229" data-mp="xrrd35nmv2vd" />
                  </div>
                </div>
              </button>;
        })}
        </div>
        <p className="mt-3 text-center text-xs text-mute" data-id="element-230" data-mp="orctcaqbhvtz">El precio PRO es el total del paquete, no un adicional.</p>
        <div className="mt-5" data-id="element-231" data-mp="jsrpm1buwu0s">
          <CTAButton href={active.href} checkout={{
          value: active.value,
          contentName: active.title,
          contentId: active.id
        }} data-id="element-232" data-mp="jsi68wlbhl42">
            {active.cta}
          </CTAButton>
        </div>
      </div>
    </section>;
}